"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const ButtonGroup_1 = __importDefault(require("../../components/ButtonGroup"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Footnotes_1 = require("../../components/Footnotes");
const Legend_1 = __importDefault(require("../../components/Legend"));
const Sources_1 = require("../../components/Sources");
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const date_1 = require("../../utilities/date");
const format_1 = require("../../utilities/format");
const measurements_1 = require("../../utilities/measurements");
const types_1 = require("../../utilities/types");
const ChartDescription_1 = __importDefault(require("./ChartDescription"));
const constants_1 = require("./constants");
const model_1 = require("./model");
const Mosaic_1 = __importDefault(require("./Mosaic"));
const ParsedTemplate_1 = __importDefault(require("./ParsedTemplate"));
require("./styles.css");
const validate_1 = require("./validate");
const MOSAIC_FONT_SIZE = 14;
const MIN_HEIGHT = 300;
const MosaicPlot = _ref => {
  let {
    title,
    subtitle,
    titleFontSize,
    subtitleFontSize,
    height,
    width,
    data: rawData,
    dropdownOptions = constants_1.DEFAULT_DROPDOWN_OPTIONS,
    groups,
    categories,
    metrics,
    defaultSelected = [],
    descriptionTemplate,
    selectedDescriptionTemplate,
    descriptionLines,
    yType,
    groupLabelTemplate = '',
    hideFooter = false,
    labelWidth = 0
  } = _ref;
  if (height && height < MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${MIN_HEIGHT}.`);
  }
  const descriptionTemplateVariables = ['yType', 'label', 'value', 'rowLabel', 'rowPercent', 'totalPercent'];
  const divRef = (0, react_1.useRef)();
  const optsDropdown = {
    ...constants_1.DEFAULT_DROPDOWN_OPTIONS,
    ...dropdownOptions
  };
  const dataIdsString = (0, utilities_1.getDataIds)(rawData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = (0, react_1.useMemo)(() => (0, utilities_1.extractDatasets)(rawData), [dataIdsString]);
  const dropdownType = (0, utilities_1.isValidAxisType)(optsDropdown.type) ? optsDropdown.type : (0, utilities_1.getAxisTypeFromData)(data, 'x') || constants_1.DEFAULT_DROPDOWN_TYPE;
  const dropdownFormat = (0, react_1.useMemo)(() => (0, utilities_1.valueFormat)({
    params: {
      format: dropdownType
    }
  }), [dropdownType]);
  const keys = (0, react_1.useMemo)(() => (0, utilities_1.extractKeys)(data, date_1.dateParser).map(i => ({
    ...i,
    parsed: dropdownFormat(i.key)
  })),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, dropdownType]);
  const {
    key: date,
    dropdown
  } = (0, utilities_1.useDropdown)({
    enabled: optsDropdown.enabled,
    keys,
    label: title ? ' ' : '',
    parser: dropdownFormat,
    sortBy: optsDropdown.sort,
    targetKey: optsDropdown.selectedItem
  });
  const [selectedCategories, setSelectedCategories] = (0, react_1.useState)(defaultSelected);
  const [selected, setSelected] = (0, react_1.useState)(null);
  const totalValue = data.map((0, model_1.getValueByDate)(date)).reduce((sum, value) => sum + value, 0);
  const totalByMetric = (0, lodash_1.default)(data).keyBy('id').mapValues((0, model_1.getValueByDate)(date)).value();
  const metricsByGroupByCategory = (0, lodash_1.default)(metrics).groupBy('group').mapValues(groups => (0, lodash_1.default)(groups).keyBy('category').mapValues(_ref2 => {
    let {
      metrics
    } = _ref2;
    return metrics;
  }).value()).value();
  const totalsByGroup = (0, lodash_1.default)(metrics).groupBy('group').mapValues(groups => (0, lodash_1.default)(groups).flatMap('metrics').map('id').value()).mapValues(ids => lodash_1.default.sumBy(ids, id => totalByMetric[id])).value();
  const totalByGroupByCategory = (0, lodash_1.default)(metrics).groupBy('group').mapValues(groups => (0, lodash_1.default)(groups).keyBy('category').mapValues(_ref3 => {
    let {
      metrics
    } = _ref3;
    return lodash_1.default.sumBy(metrics, _ref4 => {
      let {
        id
      } = _ref4;
      return totalByMetric[id];
    });
  }).value()).value();
  const proportionsBySubgroup = (0, lodash_1.default)(metrics).groupBy('group').mapValues(groups => (0, lodash_1.default)(groups).keyBy('category').mapValues(_ref5 => {
    let {
      metrics
    } = _ref5;
    return (0, lodash_1.default)(metrics).keyBy('id').mapValues(_ref6 => {
      let {
        id
      } = _ref6;
      return totalByMetric[id] / totalValue;
    }).value();
  }).value()).value();
  const subcategoriesByCategory = (0, lodash_1.default)(metrics).groupBy('category').mapValues(groups => (0, lodash_1.default)(groups).flatMap('metrics').map('name').uniq().value()).value();
  const categoryToColor = {};
  categories.forEach((_ref7, i) => {
    let {
      id,
      color
    } = _ref7;
    categoryToColor[id] = color || colors_1.DEFAULT_COLORS[i];
  });
  const {
    category,
    group,
    metric
  } = selected || {};
  const emphasisColor = category ? categoryToColor[category] : null;
  const descriptionRowLabel = group ? group.toLowerCase() : null;
  let descriptionValue = totalValue;
  let descriptionLabel = null;
  let descriptionRowPercent = null;
  let descriptionTotalPercent = null;
  const descriptionFormat = format_1.VALUE_FORMATS.percent;
  if (selected) {
    if (metric) {
      const {
        name = ''
      } = lodash_1.default.chain(metrics).find({
        group,
        category
      }).get('metrics').find({
        id: metric
      }).value() || {};
      descriptionLabel = name.toLowerCase();
      descriptionValue = totalByMetric[metric];
      descriptionRowPercent = descriptionFormat(totalByMetric[metric] / totalsByGroup[group]);
      descriptionTotalPercent = descriptionFormat(totalByMetric[metric] / totalValue);
    } else {
      const {
        label = ''
      } = lodash_1.default.find(categories, {
        id: category
      }) || {};
      descriptionLabel = label.toLowerCase();
      descriptionValue = totalByGroupByCategory[group][category];
      descriptionRowPercent = descriptionFormat(totalByGroupByCategory[group][category] / totalsByGroup[group]);
      descriptionTotalPercent = descriptionFormat(totalByGroupByCategory[group][category] / totalValue);
    }
  }
  const buttonCategories = categories.filter(_ref8 => {
    let {
      id
    } = _ref8;
    return subcategoriesByCategory[id].length > 1;
  }).map(_ref9 => {
    let {
      id,
      label
    } = _ref9;
    return {
      id,
      label,
      color: categoryToColor[id],
      selected: selectedCategories.includes(id)
    };
  });
  let footerSources = [];
  let footerSummary;
  let footnotes = [];
  const sources = (0, Sources_1.useSources)({
    data
  });
  const footerFootnotes = (0, Footnotes_1.useFootnotes)({
    data
  });
  if (!hideFooter) {
    footerSources = sources.sources;
    footerSummary = sources.summary;
    footnotes = footerFootnotes.footnotes;
  }
  if (!lodash_1.default.isEmpty((0, validate_1.validateGroups)(groups)) || !lodash_1.default.isEmpty((0, validate_1.validateCategories)(categories)) || !lodash_1.default.isEmpty((0, validate_1.validateMetrics)(groups, categories, metrics)) || !lodash_1.default.isEmpty((0, validate_1.validateTemplateString)(descriptionTemplate, descriptionTemplateVariables)) || !lodash_1.default.isEmpty((0, validate_1.validateTemplateString)(selectedDescriptionTemplate, descriptionTemplateVariables)) || !lodash_1.default.isEmpty((0, validate_1.validateTemplateString)(groupLabelTemplate, ['yType']))) {
    return null;
  }
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: "mosaic-plot",
    title: title,
    subtitle: subtitle,
    titleFontSize: titleFontSize,
    subtitleFontSize: subtitleFontSize,
    footerSources: footerSources,
    footerSummary: footerSummary,
    footnotes: footnotes,
    showFooter: !hideFooter,
    showMetricFootnotes: false,
    dropdowns: optsDropdown.show && dropdown ? [dropdown] : [],
    width: width || null,
    height: height || '100%',
    fontSize: MOSAIC_FONT_SIZE
  }, _ref10 => {
    let {
      chartWidth,
      chartHeight
    } = _ref10;
    const legendWidth = lodash_1.default.sum(categories.map(_ref11 => {
      let {
        label
      } = _ref11;
      return MOSAIC_FONT_SIZE + 4 + (0, measurements_1.textDimensions)({
        text: label,
        fontSize: MOSAIC_FONT_SIZE
      }).width + 20;
    }));
    const legendHeight = categories.length ? MOSAIC_FONT_SIZE * 2.5 * Math.ceil(legendWidth / chartWidth) + 12 : 0;
    const descriptionHeight = MOSAIC_FONT_SIZE * descriptionLines;
    const buttonHeight = buttonCategories.length ? 80 + 22 : 0;
    const minChartHeight = legendHeight + descriptionHeight + buttonHeight;
    const mosaicHeight = chartHeight - minChartHeight <= 0 ? 1 : chartHeight - minChartHeight;
    return react_1.default.createElement("div", {
      style: {
        height: chartHeight,
        minHeight: minChartHeight,
        overflow: 'visible',
        position: 'relative',
        width: '100%'
      }
    }, react_1.default.createElement(Legend_1.default, {
      ...{
        categories,
        fontSize: MOSAIC_FONT_SIZE,
        style: {
          marginBottom: 12
        }
      }
    }), react_1.default.createElement(ChartDescription_1.default, {
      hovered: selected,
      descriptionTemplate: descriptionTemplate,
      selectedDescriptionTemplate: selectedDescriptionTemplate,
      descriptionLines: descriptionLines,
      value: format_1.VALUE_FORMATS.default(descriptionValue, {
        truncate: false
      }),
      label: descriptionLabel,
      emphasisColor: emphasisColor,
      rowLabel: descriptionRowLabel,
      rowPercent: descriptionRowPercent,
      totalPercent: descriptionTotalPercent,
      yType: yType,
      fontSize: MOSAIC_FONT_SIZE
    }), react_1.default.createElement("div", {
      ref: divRef,
      style: {
        height: mosaicHeight
      }
    }, react_1.default.createElement(Mosaic_1.default, {
      ...{
        groups,
        categories,
        metricsByGroupByCategory,
        selectedCategories,
        proportionsBySubgroup,
        setSelected
      },
      height: mosaicHeight,
      width: chartWidth || 1,
      targetRef: divRef,
      unitSpan: react_1.default.createElement(ParsedTemplate_1.default, {
        template: groupLabelTemplate,
        yType: yType
      }),
      fontSize: MOSAIC_FONT_SIZE,
      labelWidth: labelWidth
    })), react_1.default.createElement(ButtonGroup_1.default, {
      categories: buttonCategories,
      onButtonClick: category => {
        if (selectedCategories.includes(category)) {
          setSelectedCategories(lodash_1.default.without(selectedCategories, category));
        } else {
          setSelectedCategories(selectedCategories.concat([category]));
        }
      }
    }));
  });
};
MosaicPlot.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Height to draw the chart. Will auto calculate if unset.
   */
  height: prop_types_1.number,
  /**
   * Width to draw the chart. Will fill container if unset.
   */
  width: prop_types_1.number,
  /**
   * IDs and labels of groups
   */
  groups: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired
  })).isRequired,
  /**
   * IDs, labels and colors of categories
   */
  categories: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    color: prop_types_1.string
  })),
  /**
   * Defines which group and category each data belongs to. Allows override of name and color.
   */
  metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    group: prop_types_1.string.isRequired,
    category: prop_types_1.string.isRequired,
    metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      name: prop_types_1.string.isRequired,
      id: prop_types_1.string.isRequired,
      color: prop_types_1.string
    }))
  })).isRequired,
  /**
   * Data for the chart
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Configuration options for dropdown
   * @param enabled {bool} set ability to change selected item
   * @param selectedItem {string} default selected item for dropdown,
   * must be an exact match in value & format to a key in data array
   * @param show {bool} show or hide dropdowns
   * @param type {string} data type - 'items','linear','unformatted','percent','dollars','years',
   * 'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   */
  dropdownOptions: (0, prop_types_1.shape)({
    enabled: prop_types_1.bool,
    selectedItem: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    show: prop_types_1.bool,
    sort: (0, prop_types_1.oneOfType)([prop_types_1.bool, (0, prop_types_1.oneOf)(['ascending', 'descending'])]),
    type: prop_types_1.string
  }),
  /**
   * The categories that are selected by default
   */
  defaultSelected: (0, prop_types_1.arrayOf)(prop_types_1.string),
  /**
   * The markup string template for the default chart description
   *
   * Variables are delimited by surround them in curly braces. ex: {variable}
   * Text transformation can be applied to the variable after a dot. ex: {variable.capitalize}
   * Variables can be bolded by surrounding the curly braces with underscores. ex: _{variable}_
   * Variables can be bolded and colored by surrounding the curly braces asterisks. ex: *{variable}*
   *
   * Supported Variables:
   * - rowLabel     (string) - Ex: 'white'
   * - label        (string) - Ex: 'murder'
   * - value        (number) - Ex: 10000
   * - yType        (string) - Ex: 'prisoners'
   * - rowPercent   (string) - Ex: '10%'
   * - totalPercent (string) - Ex: '1%'
   *
   * Supported text transforms: capitalize, uppercase, lowercase
   */
  descriptionTemplate: prop_types_1.string.isRequired,
  /**
   * The markup string template for the focused/hovered chart description
   *
   * Variables are delimited by surround them in curly braces. ex: {variable}
   * Text transformation can be applied to the variable after a dot. ex: {variable.capitalize}
   * Variables can be bolded by surrounding the curly braces with underscores. ex: _{variable}_
   * Variables can be bolded and colored by surrounding the curly braces asterisks. ex: *{variable}*
   *
   * Supported Variables:
   * - rowLabel     (string) - Ex: 'white'
   * - label        (string) - Ex: 'murder'
   * - value        (number) - Ex: 10000
   * - yType        (string) - Ex: 'prisoners'
   * - rowPercent   (string) - Ex: '10%'
   * - totalPercent (string) - Ex: '1%'
   *
   * Supported text transforms: capitalize, uppercase, lowercase
   */
  selectedDescriptionTemplate: prop_types_1.string.isRequired,
  /**
   * The max number of lines that the description should wrap to (controls the height of the chart
   * description container)
   */
  descriptionLines: prop_types_1.number.isRequired,
  /**
   * The quantity type that the mosaic chart is proportioning (e.g. 'people')
   */
  yType: prop_types_1.string.isRequired,
  /**
   * The markup string template for the group label (e.g. 'of People')
   *
   * Variables are delimited by surround them in curly braces. ex: {variable}
   * Text transformation can be applied to the variable after a dot. ex: {variable.capitalize}
   * Variables can be bolded by surrounding the curly braces with underscores. ex: _{variable}_
   * Variables can be bolded and colored by surrounding the curly braces asterisks. ex: *{variable}*
   *
   * Supported Variables:
   * - yType        (string) - Ex: 'people'
   *
   * Supported text transforms: capitalize, uppercase, lowercase
   */
  groupLabelTemplate: prop_types_1.string,
  /**
   * Flag to hide sources footer. Defaults to false.
   */
  hideFooter: prop_types_1.bool,
  /**
   * Allows manual override of label section width
   */
  labelWidth: prop_types_1.number
};
exports.default = MosaicPlot;